import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Icon, Container, Header, Label } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import ChainsEditor from './ChainsEditor';
import { setEditedEntity, confirmDelete, deleteChain } from '../../../actions';
import RestaurantSetupEditor from './RestaurantSetupEditor';
import { hasBusinessPermission } from '../../../helpers/permissions';

import './Chains.scss';

class Chains extends Component {
    constructor(props) {
        super(props);

        this.renderCreationButton = this.renderCreationButton.bind(this);
    }

    handleDelete = (chain) => {
        this.props.confirmDelete(chain.name, () => this.props.deleteChain(chain.id));
    }

    getPosSupplierId = (chainId) => {
        const rest = this.props.restaurants.find(rest => rest.ownerId === chainId);
        return rest && rest.posSupplierId;
    }

    renderCreationButton() {
        if (!hasBusinessPermission('operation')) return null;

        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                floated="right"
                primary
                onClick={() => setEditedEntity('chain')}
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { chains, setEditedEntity, onEdit, editedType } = this.props;

        const columns = [{
            id: 'id',
            Header: '#',
            accessor: chain => parseInt(chain.id),
            maxWidth: 75,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            filterable: true
        }, {
            Header: i18next.t('name'),
            accessor: 'name',
            filterable: true
        }, {
            id: 'restaurantsCount',
            Header: i18next.t('chains.restaurantsCount'),
            accessor: chain => this.props.restaurants.filter(rest => rest.ownerId === chain.id).length,
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            maxWidth: 142,
            sortable: false,
            filterable: false,
            Cell: row => {
                const chain = row.original;

                return (
                    <div>
                        <Button circular size='tiny' primary icon='find' onClick={() => this.props.history.push(`/chain/${chain.id}`)} />
                        {hasBusinessPermission('operation') && <Button circular size='tiny' icon='write' basic onClick={() => setEditedEntity('chain', chain)} />}
                        {hasBusinessPermission('operation') && <Button circular size='tiny' icon='plus' positive onClick={() => setEditedEntity('restaurant', { ownerId: chain.id, posSupplierId: this.getPosSupplierId(chain.id) })} />}
                        {hasBusinessPermission('operation') && <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(chain)} />}
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('chain.name')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <ChainsEditor />
                </SideEditor>
                <SideEditor
                    title={i18next.t('restaurant')}
                    visible={editedType === 'restaurant'}
                    handleClose={() => setEditedEntity(null)}
                >
                    <RestaurantSetupEditor />
                </SideEditor>

                <DataGrid
                    data={chains}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        return {};
                    }}
                    SubComponent={row => {
                        const chain = row.original;
                        const chainRestaurants = this.props.restaurants.filter(rest => rest.ownerId === chain.id);
                        let restTagNames;

                        if (chainRestaurants && chainRestaurants.length > 0) {
                            restTagNames = chainRestaurants.map(rest => ({ id: rest.id, name: rest.name })).sort((tag1, tag2) => tag1.name < tag2.name ? -1 : 1);
                        }

                        return (
                            <Container className=''>
                                <Header size='medium'>
                                    <Header.Content>{i18next.t('restaurants')}: </Header.Content>
                                </Header>
                                <div className='restaurants-tags-container'>
                                    {
                                        restTagNames ?
                                            restTagNames.map((tag, index) => (
                                                <Label key={index} className='restaurant-tag' as={Link} to={`/restaurant/${tag.id}`}>
                                                    #{tag.id} {tag.name}
                                                </Label>
                                            )) : i18next.t('general.none')
                                    }
                                </div>

                            </Container>
                        );
                    }}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />
            </div>
        );
    }
}

Chains.propTypes = {
    chains: PropTypes.array,
    restaurants: PropTypes.array,
    onEdit: PropTypes.bool,
    editedType: PropTypes.string,
    setEditedEntity: PropTypes.func,
    confirmDelete: PropTypes.func,
    deleteChain: PropTypes.func,
    history: PropTypes.object,
    
};

const mapStateToProps = (state, ownProps) => {
    const { restaurants, chains } = state.businessApp;
    const onEdit = state.editor.type === 'chain';
    const { type: editedType } = state.editor;

    return { chains, onEdit, restaurants, editedType };
};

export default connect(mapStateToProps,
    { setEditedEntity, confirmDelete, deleteChain })(Chains);
